import { alpha, darken } from '@mui/material/styles';

// Completar a medida que se usa, podes usar alpha o darken para aclarar o oscurecer un cierto color.
// 100 es el mas claro posible, 1000 el mas oscuro. Tratar de usar múltiplos de 100.

export const typography = {
    themes: {
        cultivio: {
            fontFamily: 'BayerSansWeb, "Roboto", sans-serif',
        },
        latijereta: {
            fontFamily: 'BayerSansWeb, "Roboto", sans-serif',
        },
        expertobayer: {
            fontFamily: 'BayerSansWeb, "Roboto", sans-serif',
        },
        agroeste: {
            fontFamily: 'BayerSansWeb, "Roboto", sans-serif',
        },
        agroceres: {
            fontFamily: 'BayerSansWeb, "Roboto", sans-serif',
        },
        md: {
            fontFamily: 'BayerSansWeb, "Roboto", sans-serif',
        },
        dekalb: {
            fontFamily: 'BayerSansWeb, "Roboto", sans-serif',
        },
        fieldview: {
            fontFamily: 'BayerSansWeb, "Roboto", sans-serif',
        },
    },
    fontFamily: 'BayerSansWeb, "Roboto", sans-serif',
    fontSize: '1rem',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
};

const colors = {
    warning: {
        default: '#d44d21',
        100: '#fc8259',
        200: '#FFF7DB',
        300: '#9b0000',
        500: '#9f3714',
        600: '#FFD649',
        700: '#D34F21',
    },
    input: {
        fontColor: 'rgb(142, 142, 142)',
    },
    cropMonitoring: {
        grayLine: '#dadada',
        emergence: '#97723a',
        flowering: '#9ad15e',
        maturity: '#006a28',
        harvested: '#eed21d',
        mute: '#a8a8a8',
        redPoint: '#ff0000',
        graphic: '#82ca9d',
        up: {
            default: '#f0b53b',
            100: '#feecbf',
        },
        down: {
            default: '#7ab3ff',
            100: '#eaf3ff',
        },
        equal: {
            default: '#9ad15e',
            100: '#f0f8e7',
        },
    },
    gray: {
        default: '#8e8e8e',
        100: '#01010103',
        200: '#F2F2F2',
        300: '#e2e7e9',
        400: '#f0f0f0',
        500: '#f2f2f2',
        700: '#f8f8f8',
        800: '#C4C4C4',
    },
    dark: {
        default: '#000000',
    },
    success: {
        default: '#2e7d32',
        100: '#edf7ed',
        200: '#269E40',
    },
    error: {
        100: '#F1E9E9',
        200: '#F8A2A2',
    },
    references: {
        default: {
            0: '#00CC66',
            1: '#A9D18E',
            2: '#FFE699',
            3: '#F4B183',
            4: '#FF7C80',
        },
        toxicology: {
            0: '#e20712',
            1: '#fab800',
            2: '#1960aa',
            3: '#04a54b',
        },
        other: {
            0: '#fef2cc',
            1: '#bfbfbf',
            2: '#9fb1cd',
        },
    },
    themes: {
        cultivio: {
            mui: {
                primary: {
                    primary: '#006a28',
                    onSurface: '#006a28',
                    variant: '#7FB493',
                    snackbarVariant: '#B2D2BE',
                    infoBackground: '#E7F8FF',
                    itemSelectedBackground: '#EEFFEF',
                    colors: {
                        active: '#FFFFFF',
                        inactive: alpha('#006a28', 0.8),
                        disabled: alpha('#006a28', 0.38),
                        stroke: alpha('#006a28', 0.12),
                        base: '#FFFFFF',
                    },
                },
                secondary: {
                    secondary: '#4D4D4D',
                    onSurface: '#009B3A',
                    variant: '#A6A6A6',
                    snackbarVariant: '#C9C9C9',
                    colors: {
                        active: '#FFFFFF',
                        inactive: alpha('#4D4D4D', 0.8),
                        disabled: alpha('#4D4D4D', 0.38),
                        stroke: alpha('#4D4D4D', 0.12),
                        base: '#4F432B',
                    },
                },
            },
            primary: {
                default: '#006a28',
                100: alpha('#006a28', 0.05),
                200: alpha('#006a28', 0.1),
                300: alpha('#006a28', 0.15),
                400: '#9ad15e',
                600: darken('#006a28', 0.1),
            },
            secondary: {
                default: '#4d9769',
            },
            accent: {
                default: '#9ad15e',
            },
            warning: {
                default: '#d44d21',
                100: '#d44d21',
                200: '#FFF7DB',
                300: '#9b0000',
                500: '#9f3714',
                600: '#FFD649',
                700: '#D34F21',
            },
            success: {
                default: '#2e7d32',
                100: '#edf7ed',
                200: '#269E40',
            },
        },
        latijereta: {
            mui: {
                primary: {
                    primary: '#0E98D7',
                    onSurface: '#0E98D7',
                    variant: '#86CBEB',
                    snackbarVariant: '#B6E0F3',
                    infoBackground: '#E7F8FF',
                    itemSelectedBackground: '#E7F8FF',
                    colors: {
                        active: '#FFFFFF',
                        inactive: alpha('#0E98D7', 0.8),
                        disabled: alpha('#0E98D7', 0.38),
                        stroke: alpha('#0E98D7', 0.12),
                        base: '#0E98D7',
                    },
                },
                secondary: {
                    secondary: '#4D4D4D',
                    onSurface: '#54ACEE',
                    variant: '#A6A6A6',
                    snackbarVariant: '#C9C9C9',
                    colors: {
                        active: '#FFFFFF',
                        inactive: alpha('#4D4D4D', 0.8),
                        disabled: alpha('#4D4D4D', 0.38),
                        stroke: alpha('#4D4D4D', 0.12),
                        base: '#4F432B',
                    },
                },
            },
            primary: {
                default: '#0362aa',
                100: alpha('#0362aa', 0.05),
                200: alpha('#0362aa', 0.1),
                300: alpha('#0362aa', 0.15),
                400: '#00bcff',
                600: darken('#0362aa', 0.1),
            },
            secondary: {
                default: '#4189bf',
            },
            accent: {
                default: '#9ed5ff',
            },
            warning: {
                default: '#d44d21',
                100: '#d44d21',
                200: '#FFF7DB',
                300: '#9b0000',
                500: '#9f3714',
                600: '#FFD649',
                700: '#D34F21',
            },
            success: {
                default: '#2e7d32',
                100: '#edf7ed',
                200: '#269E40',
            },
        },
        expertobayer: {
            mui: {
                primary: {
                    primary: '#10384F',
                    onSurface: '#006F9B',
                    variant: '#00BCFF',
                    snackbarVariant: '#A4E7FF',
                    infoBackground: '#E7F8FF',
                    itemSelectedBackground: '#FFDCE4',
                    colors: {
                        active: '#10384F',
                        inactive: alpha('#10384F', 0.73),
                        disabled: alpha('#10384F', 0.38),
                        stroke: alpha('#10384F', 0.12),
                        base: '#10384F',
                    },
                },
                secondary: {
                    secondary: '#DE0043',
                    onSurface: '#DE0043',
                    variant: '#443247',
                    snackbarVariant: '#FF7596',
                    colors: {
                        active: '#FFFFFF',
                        inactive: alpha('#DE0043', 0.91),
                        disabled: alpha('#DE0043', 0.38),
                        stroke: alpha('#DE0043', 0.12),
                        base: '#FFFFFF',
                    },
                },
            },
            secondary: {
                default: '#DE0043',
                100: '#FCE8EE',
                200: '#EB618A',
                300: '#FCE8EE',
            },
            primary: {
                50: '#516E7F',
                default: '#10384F',
                100: '#CFD7DC',
                200: '#CFD7DC',
                300: '#CFD7DC',
                400: '#10384F',
                600: '#2D5064',
            },
            accent: {
                default: '#6B8492',
            },
            warning: {
                default: '#B85302',
                50: '#FFE4CD',
                100: '#B85302',
                200: '#d39462',
                300: '#f9770c',
                500: '#9f3714',
                600: '#974401',
                700: '#652D02',
            },
            success: {
                default: '#01830C',
                100: '#63b268',
                200: '#269E40',
            },
            error: {
                default: '#b85303',
            },
        },
        agroeste: {
            mui: {
                primary: {
                    primary: '#0E98D7',
                    onSurface: '#0E98D7',
                    variant: '#86CBEB',
                    snackbarVariant: '#B6E0F3',
                    infoBackground: '#E7F8FF',
                    itemSelectedBackground: '#E7F8FF',
                    colors: {
                        active: '#FFFFFF',
                        inactive: alpha('#0E98D7', 0.8),
                        disabled: alpha('#0E98D7', 0.38),
                        stroke: alpha('#0E98D7', 0.12),
                        base: '#0E98D7',
                    },
                },
                secondary: {
                    secondary: '#4D4D4D',
                    onSurface: '#54ACEE',
                    variant: '#A6A6A6',
                    snackbarVariant: '#C9C9C9',
                    colors: {
                        active: '#FFFFFF',
                        inactive: alpha('#4D4D4D', 0.8),
                        disabled: alpha('#4D4D4D', 0.38),
                        stroke: alpha('#4D4D4D', 0.12),
                        base: '#4F432B',
                    },
                },
            },
            primary: {
                default: '#0e98d7',
                100: alpha('#0e98d7', 0.05),
                200: alpha('#0e98d7', 0.1),
                300: alpha('#0e98d7', 0.15),
                400: alpha('#0e98d7', 0.15),
                600: darken('#0e98d7', 0.1),
            },
            secondary: {
                default: '#54acee',
            },
            accent: {
                default: '#9ed5ff',
            },
            warning: {
                default: '#d44d21',
                100: '#d44d21',
                200: '#FFF7DB',
                300: '#9b0000',
                500: '#9f3714',
                600: '#FFD649',
                700: '#D34F21',
            },
            success: {
                default: '#2e7d32',
                100: '#edf7ed',
                200: '#269E40',
            },
        },
        agroceres: {
            mui: {
                primary: {
                    primary: '#006a28',
                    onSurface: '#006a28',
                    variant: '#7FB493',
                    snackbarVariant: '#B2D2BE',
                    infoBackground: '#E7F8FF',
                    itemSelectedBackground: '#EEFFEF',
                    colors: {
                        active: '#FFFFFF',
                        inactive: alpha('#006a28', 0.8),
                        disabled: alpha('#006a28', 0.38),
                        stroke: alpha('#006a28', 0.12),
                        base: '#FFFFFF',
                    },
                },
                secondary: {
                    secondary: '#4D4D4D',
                    onSurface: '#009B3A',
                    variant: '#A6A6A6',
                    snackbarVariant: '#C9C9C9',
                    colors: {
                        active: '#FFFFFF',
                        inactive: alpha('#4D4D4D', 0.8),
                        disabled: alpha('#4D4D4D', 0.38),
                        stroke: alpha('#4D4D4D', 0.12),
                        base: '#4F432B',
                    },
                },
            },
            primary: {
                default: '#006a28',
                100: alpha('#006a28', 0.05),
                200: alpha('#006a28', 0.1),
                300: alpha('#006a28', 0.15),
                400: alpha('#006a28', 0.15),
                600: darken('#006a28', 0.1),
            },
            secondary: {
                default: '#4d9769',
            },
            accent: {
                default: '#9ad15e',
            },
            warning: {
                default: '#d44d21',
                100: '#d44d21',
                200: '#FFF7DB',
                300: '#9b0000',
                500: '#9f3714',
                600: '#FFD649',
                700: '#D34F21',
            },
            success: {
                default: '#2e7d32',
                100: '#edf7ed',
                200: '#269E40',
            },
        },
        md: {
            mui: {
                secondary: {
                    secondary: '#00bcff',
                    onSurface: '#00bcff',
                    variant: '#00bcff',
                    snackbarVariant: '#00bcff',
                    infoBackground: '#E7F8FF',
                    itemSelectedBackground: '#E7F8FF',
                    colors: {
                        active: '#00bcff',
                        inactive: alpha('#00bcff', 0.73),
                        disabled: alpha('#00bcff', 0.38),
                        stroke: alpha('#00bcff', 0.12),
                        base: '#00bcff',
                    },
                },
            },
            primary: {
                default: '#00bcff',
                100: alpha('#00bcff', 0.05),
                200: alpha('#00bcff', 0.1),
                300: alpha('#00bcff', 0.15),
                400: alpha('#00bcff', 0.15),
                600: darken('#00bcff', 0.1),
            },
            secondary: {
                default: '#006a28',
            },
            accent: {
                default: '#b5d9e9;',
            },
            success: {
                default: '#2e7d32',
                100: '#edf7ed',
                200: '#269E40',
            },
            warning: {
                default: '#d44d21',
                100: '#d44d21',
                200: '#FFF7DB',
                300: '#9b0000',
                500: '#9f3714',
                600: '#FFD649',
                700: '#D34F21',
            },
        },
        dekalb: {
            mui: {
                primary: {
                    primary: '#d9ab01',
                    onSurface: '#4F432B',
                    variant: '#897E61',
                    snackbarVariant: '#BCB4A2',
                    infoBackground: '#FFFFFF',
                    itemSelectedBackground: '#FFFFFF',
                    colors: {
                        active: '#c29900',
                        inactive: alpha('#4F432B', 0.8),
                        disabled: alpha('#4F432B', 0.38),
                        stroke: alpha('#4F432B', 0.12),
                        base: '#4F432B',
                    },
                },
                secondary: {
                    secondary: '#000000DE',
                    onSurface: '#FFBD04',
                    variant: '#A6A6A6',
                    snackbarVariant: '#C9C9C9',
                    colors: {
                        active: '#FFFFFF',
                        inactive: alpha('#4D4D4D', 0.8),
                        disabled: alpha('#4D4D4D', 0.38),
                        stroke: alpha('#4D4D4D', 0.12),
                        base: '#4F432B',
                    },
                },
            },
            primary: {
                default: '#d9ab01',
                100: alpha('#d9ab01', 0.05),
                200: alpha('#d9ab01', 0.1),
                300: alpha('#d9ab01', 0.15),
                400: '#d9ab01',
                500: '#eba900',
                600: darken('#d9ab01', 0.1),
                700: '#FF8A01',
            },
            secondary: {
                default: '#ffd848',
            },
            accent: {
                default: '#ffe584',
            },
            success: {
                default: '#2e7d32',
                100: '#edf7ed',
                200: '#269E40',
            },
            warning: {
                default: '#d44d21',
                100: '#d44d21',
                200: '#FFF7DB',
                300: '#9b0000',
                500: '#9f3714',
                600: '#FFD649',
                700: '#D34F21',
            },
        },
        fieldview: {
            mui: {
                primary: {
                    primary: '#454545',
                    onSurface: '#006F9B',
                    variant: '#00BCFF',
                    snackbarVariant: '#A4E7FF',
                    infoBackground: '#E7F8FF',
                    itemSelectedBackground: '#F1F6FE',
                    colors: {
                        active: '#10384F',
                        inactive: alpha('#454545', 0.73),
                        disabled: alpha('#10384F', 0.38),
                        stroke: alpha('#10384F', 0.12),
                        base: '#10384F',
                    },
                },
                secondary: {
                    secondary: '#0743F9',
                    onSurface: '#DE0043',
                    variant: '#443247',
                    snackbarVariant: '#FF7596',
                    colors: {
                        active: '#FFFFFF',
                        inactive: alpha('#454545', 0.73),
                        disabled: alpha('#DE0043', 0.38),
                        stroke: alpha('#DE0043', 0.12),
                        base: '#FFFFFF',
                    },
                },
            },
            primary: {
                50: alpha('#454545', 0.73),
                default: '#454545',
                100: '#CFD7DC',
                200: '#CFD7DC',
                300: '#CFD7DC',
                400: '#10384F',
                600: '#002ECD',
            },
            secondary: {
                default: '#0743F9',
                100: '#FCE8EE',
                200: '#EB618A',
                300: '#FCE8EE',
            },

            accent: {
                default: '#6B8492',
            },
            warning: {
                default: '#B85302',
                50: '#FFE4CD',
                100: '#B85302',
                200: '#d39462',
                300: '#f9770c',
                500: '#9f3714',
                600: '#974401',
                700: '#652D02',
            },
            success: {
                default: '#01830C',
                100: '#63b268',
                200: '#269E40',
            },
        },
    },
};

export default colors;
